import { assertNotEmpty } from '@festina-life/core'
import { useTranslate } from '@festina-life/ui/hooks'
import { Icon } from '@festina-life/ui/structure'
import cx from 'classnames'

import { useTemplateContext } from '../../context/templateContext'
import {
  isValueSetupFieldValue,
  type TemplateField,
} from '../../types/templateModel'
import { createLiteralTypeInformation } from '../fplusExpression/expressionType'
import { TemplateFieldExpression } from '../templateFieldExpression/TemplateFieldExpression'

type Props = {
  field: TemplateField
}

export const TemplateFieldRequiredCell = ({ field }: Props) => {
  const translate = useTranslate()
  const { templateVersion } = useTemplateContext()
  assertNotEmpty(templateVersion)

  if (!isValueSetupFieldValue(field.value)) {
    return null
  }

  const requiredExpression = field.value.required?.expression
  const requiredInModelInstanceExpression =
    field.value.requiredInModelInstance?.expression

  return (
    <div
      className={cx('flex h-full w-full', {
        'gap-x-2':
          requiredExpression?.fplusSource &&
          requiredInModelInstanceExpression?.fplusSource,
      })}
      // This key is necessary in order for the flexed contents to be relayed out
      key={`${requiredExpression?.fplusSource}${requiredInModelInstanceExpression?.fplusSource}`}
    >
      {requiredExpression?.fplusSource && (
        <TemplateFieldExpression
          expression={requiredExpression}
          isExpanded={false}
          path={field.value.required!.path}
          overflowTitle={translate(
            'templateViewer.requiredColumn.overflowTitles.required',
          )}
          fallbackCode=""
          typeInformation={createLiteralTypeInformation({
            literalType: 'boolean',
            source: requiredExpression.fplusSource,
          })}
          fromOrigin={field.value.required?.origin}
        />
      )}
      {requiredInModelInstanceExpression?.fplusSource && (
        <div className="relative size-full overflow-visible">
          <Icon
            name="RectangleGroup"
            size="lg"
            className="absolute right-2 top-1/2 -translate-y-1/2"
          />
          <TemplateFieldExpression
            expression={requiredInModelInstanceExpression}
            isExpanded={false}
            path={field.value.requiredInModelInstance!.path}
            overflowTitle={translate(
              'templateViewer.requiredColumn.overflowTitles.requiredInModelInstance',
            )}
            fallbackCode=""
            typeInformation={createLiteralTypeInformation({
              literalType: 'boolean',
              source: requiredInModelInstanceExpression.fplusSource,
            })}
            fromOrigin={field.value.requiredInModelInstance?.origin}
          />
        </div>
      )}
    </div>
  )
}
